var localStorage = window.localStorage;
export var get = function (key) {
    var str = localStorage.getItem(key);
    if (!str)
        return;
    return JSON.parse(str);
};
export var set = function (key, data) {
    if (!data) {
        localStorage.removeItem(key);
        return;
    }
    localStorage.setItem(key, JSON.stringify(data));
};
